var map = {
	"./": 97,
	"./App": 147,
	"./App.js": 147,
	"./assets/images/amenities/blue-suit.jpg": 413,
	"./assets/images/amenities/butler-opening-cardoor.jpg": 414,
	"./assets/images/amenities/butler-with-champagne.jpg": 415,
	"./assets/images/amenities/butler-with-ipad.jpg": 416,
	"./assets/images/amenities/gryphon-house-business-centre.jpg": 230,
	"./assets/images/amenities/gryphon-house-car-park-foyer.jpg": 231,
	"./assets/images/amenities/gryphon-house-club-lounge.jpeg": 232,
	"./assets/images/amenities/gryphon-house-gym.jpg": 233,
	"./assets/images/amenities/gryphon-house-spa.jpg": 234,
	"./assets/images/amenities/preparing-drink.jpg": 417,
	"./assets/images/amenities/royal-curator-watermark.png": 235,
	"./assets/images/amenities/woman-beside-pool.jpg": 418,
	"./assets/images/amenities/yoga-mat.jpg": 419,
	"./assets/images/contact/gh-map-logo-highlight.png": 119,
	"./assets/images/contact/illustration-bell.png": 236,
	"./assets/images/creation/arbutus-greenway-rendering.jpeg": 420,
	"./assets/images/creation/building-fade.jpg": 237,
	"./assets/images/creation/coffee-tables.jpg": 421,
	"./assets/images/creation/fcdg-dale.jpg": 422,
	"./assets/images/creation/fcdg-tim.jpg": 423,
	"./assets/images/creation/gryphon-house-amenity-dining.jpg": 238,
	"./assets/images/creation/gryphon-house-east-view-cropped.jpg": 239,
	"./assets/images/creation/gryphon-house-exterior-entrance.jpg": 240,
	"./assets/images/creation/gryphon-house-kitchen-living.jpg": 241,
	"./assets/images/creation/gryphon-house-lobby.jpg": 120,
	"./assets/images/creation/gryphon-house-sidewalk.jpg": 121,
	"./assets/images/creation/gryphon-house-storefront.jpg": 242,
	"./assets/images/creation/gryphon-house-transform-1.jpeg": 243,
	"./assets/images/creation/gryphon-house-transform-2.jpeg": 244,
	"./assets/images/creation/gryphon-house-transform-3.jpeg": 245,
	"./assets/images/creation/gryphon-house-transform-4.jpeg": 246,
	"./assets/images/creation/illustration-building-southeast.png": 247,
	"./assets/images/creation/illustration-building-wide.png": 424,
	"./assets/images/creation/illustration-interior-design.png": 248,
	"./assets/images/creation/london-apartment-facade.jpg": 425,
	"./assets/images/creation/london-bank-district.jpg": 426,
	"./assets/images/creation/paris-aerial.jpg": 427,
	"./assets/images/creation/taizo-yamamoto-architecture-plans.jpg": 428,
	"./assets/images/creation/west-blvd-aerial.jpg": 429,
	"./assets/images/design/british-museum-glass-roof.jpg": 430,
	"./assets/images/design/gryphon-house-angle-view.jpg": 431,
	"./assets/images/design/gryphon-house-appliances.jpg": 249,
	"./assets/images/design/gryphon-house-bedroom-window-view.jpg": 250,
	"./assets/images/design/gryphon-house-bedroom.jpg": 251,
	"./assets/images/design/gryphon-house-countertops.jpg": 252,
	"./assets/images/design/gryphon-house-east-view-closeup.jpg": 253,
	"./assets/images/design/gryphon-house-exterior-entrance-closeup.jpg": 254,
	"./assets/images/design/gryphon-house-living-dining-closeup.jpeg": 432,
	"./assets/images/design/gryphon-house-living-dining-dark.jpg": 255,
	"./assets/images/design/gryphon-house-living-dining-light.jpg": 256,
	"./assets/images/design/gryphon-house-rooftop.jpeg": 257,
	"./assets/images/design/gryphon-house-terraces.jpeg": 258,
	"./assets/images/general/gold-foil-1px.png": 433,
	"./assets/images/general/gold-foil-2px.png": 434,
	"./assets/images/general/gold-foil.jpg": 66,
	"./assets/images/general/limestone-background.jpg": 259,
	"./assets/images/general/menu-bkg-mobile.jpg": 199,
	"./assets/images/general/menu-bkg-tablet.jpg": 200,
	"./assets/images/gh-painting-hero-TEMP.jpg": 435,
	"./assets/images/home/afternoon-tea.jpg": 436,
	"./assets/images/home/arbutus-greenway-cropped.jpg": 437,
	"./assets/images/home/church-exterior.jpg": 438,
	"./assets/images/home/dress-shoes.jpg": 439,
	"./assets/images/home/gryphon-house-aerial-glow.jpg": 440,
	"./assets/images/home/gryphon-house-building-left.jpg": 441,
	"./assets/images/home/gryphon-house-lobby-widecrop.jpg": 442,
	"./assets/images/home/gryphon-house-storefront.jpg": 443,
	"./assets/images/home/illustration-horseback-riding.png": 444,
	"./assets/images/home/illustration-kerrisdale-full.png": 445,
	"./assets/images/home/jinray-circular-balcony.jpg": 446,
	"./assets/images/home/thomas-hobbs-florist.jpg": 447,
	"./assets/images/home/wall-of-flowers.jpg": 448,
	"./assets/images/icons/chevron-dark.png": 449,
	"./assets/images/icons/chevron-dark.svg": 122,
	"./assets/images/icons/close-gold.png": 450,
	"./assets/images/icons/close-gold.svg": 198,
	"./assets/images/icons/close-taupe.svg": 260,
	"./assets/images/icons/icon-chevron-light.svg": 73,
	"./assets/images/icons/icon-facebook.png": 451,
	"./assets/images/icons/icon-facebook.svg": 261,
	"./assets/images/icons/icon-fastforward15.png": 262,
	"./assets/images/icons/icon-ig.png": 452,
	"./assets/images/icons/icon-ig.svg": 453,
	"./assets/images/icons/icon-line.svg": 263,
	"./assets/images/icons/icon-menu-taupe.svg": 264,
	"./assets/images/icons/icon-pause.png": 265,
	"./assets/images/icons/icon-play-purple.png": 266,
	"./assets/images/icons/icon-play.png": 267,
	"./assets/images/icons/icon-replay.png": 268,
	"./assets/images/icons/icon-rewind15.png": 269,
	"./assets/images/icons/icon-sound-off.png": 270,
	"./assets/images/icons/icon-sound-on.png": 271,
	"./assets/images/icons/icon-twitter.png": 454,
	"./assets/images/icons/icon-twitter.svg": 455,
	"./assets/images/icons/menu-gold.png": 456,
	"./assets/images/icons/menu-gold.svg": 197,
	"./assets/images/icons/play-video.png": 272,
	"./assets/images/icons/play-video.svg": 457,
	"./assets/images/location/arbutus-greenway-rendering.jpeg": 458,
	"./assets/images/location/arbutus-greenway-rendering.jpg": 273,
	"./assets/images/location/barcelona-las-ramblas.jpg": 274,
	"./assets/images/location/bike-at-storefront.jpg": 459,
	"./assets/images/location/crofton-house-school.jpg": 460,
	"./assets/images/location/dress-in-shop.jpg": 461,
	"./assets/images/location/gh-neighbourhood-map.png": 462,
	"./assets/images/location/gryphon-house-map-base.png": 463,
	"./assets/images/location/house-in-treeline.jpg": 464,
	"./assets/images/location/illustration-arbutus-greenway.png": 465,
	"./assets/images/location/illustration-kerrisdale-stripped.png": 466,
	"./assets/images/location/illustration-ubc.png": 467,
	"./assets/images/location/kerrisdale-clock.jpg": 468,
	"./assets/images/location/magee-secondary-school.jpg": 469,
	"./assets/images/location/map/gh-map-education-tc.png": 275,
	"./assets/images/location/map/gh-map-education.png": 276,
	"./assets/images/location/map/gh-map-enjoyment-tc.png": 277,
	"./assets/images/location/map/gh-map-enjoyment.png": 278,
	"./assets/images/location/map/gh-map-greenspace-tc.png": 279,
	"./assets/images/location/map/gh-map-greenspace.png": 280,
	"./assets/images/location/map/gh-map-high-street-tc.png": 281,
	"./assets/images/location/map/gh-map-high-street.png": 282,
	"./assets/images/location/map/gh-map-mobile-tc.png": 123,
	"./assets/images/location/map/gh-map-mobile.png": 124,
	"./assets/images/location/newyork-highline.jpg": 283,
	"./assets/images/location/paris-champs-elysees.jpg": 284,
	"./assets/images/location/school-stone-facade.jpg": 470,
	"./assets/images/location/students-in-uniform.jpg": 471,
	"./assets/images/location/walking-with-horse.jpg": 472,
	"./assets/images/location/west-blvd-aerial-closeup.jpg": 473,
	"./assets/images/logo.svg": 474,
	"./assets/images/logos/est-kerrisdale-vancouver.png": 112,
	"./assets/images/logos/gryphon-logo.png": 285,
	"./assets/images/logos/gryphon-logo.svg": 125,
	"./assets/images/logos/gryphonhouse-adjusted-logo-gold.png": 286,
	"./assets/images/logos/gryphonhouse-adjusted-logo-gold.svg": 111,
	"./assets/images/logos/gryphonhouse-logo-gold.png": 113,
	"./assets/images/logos/gryphonhouse-logo-gold.svg": 287,
	"./assets/images/logos/logo-atelier-dark.png": 126,
	"./assets/images/logos/logo-atelier-gold.svg": 127,
	"./assets/images/logos/logo-atelier-white.png": 288,
	"./assets/images/logos/logo-musee-white.png": 289,
	"./assets/images/logos/logo-royal-curator-white.png": 290,
	"./assets/images/logos/master-logo-map@2x.png": 291,
	"./assets/images/logos/master-real-estate.svg": 292,
	"./assets/images/logos/master-real-estate_new.svg": 293,
	"./assets/images/logos/royal-curator-logo.png": 128,
	"./assets/images/menu/hero-artist-in-grand-dining.jpg": 206,
	"./assets/images/menu/hero-artist-in-grand-hall.jpeg": 201,
	"./assets/images/menu/hero-bedroom-interiors.jpg": 205,
	"./assets/images/menu/hero-design-interiors.jpg": 204,
	"./assets/images/menu/hero-interior-kitchen.jpg": 208,
	"./assets/images/menu/hero-interior-living-room.jpg": 475,
	"./assets/images/menu/hero-kerrisdale-aerial.jpeg": 203,
	"./assets/images/menu/hero-lobby-concierge.jpg": 207,
	"./assets/images/menu/hero-painting-on-canvas.jpg": 202,
	"./assets/images/menu/hero-william-merritt-chase-painting.jpeg": 59,
	"./assets/images/philosophy/art-lives-here.png": 294,
	"./assets/images/philosophy/atelier-background.jpg": 295,
	"./assets/images/philosophy/curator-background.jpg": 296,
	"./assets/images/philosophy/gryphon-logomark.png": 129,
	"./assets/images/philosophy/jinray-artfair.jpg": 297,
	"./assets/images/philosophy/jinray-eurostar.jpg": 298,
	"./assets/images/philosophy/jinray-logo.png": 299,
	"./assets/images/philosophy/jinray-resort.jpg": 300,
	"./assets/images/philosophy/musee-background.jpg": 301,
	"./assets/images/philosophy/musee-sculpture-lady.jpg": 302,
	"./assets/images/philosophy/taizo-yamamoto-desk-tall.jpeg": 303,
	"./assets/images/philosophy/taizo-yamamoto-desk-wide.jpeg": 304,
	"./assets/images/philosophy/westbury-living.jpg": 305,
	"./assets/images/philosophy/westbury-rooftop.jpg": 306,
	"./assets/images/philosophy/wooden-thin-panels.jpg": 307,
	"./assets/images/philosophy/wooden-wing-panels.jpg": 308,
	"./assets/images/register/gryphon-house-exterior-entrance.jpg": 130,
	"./assets/images/residences/artist-in-grand-hall-flipped.jpg": 476,
	"./assets/images/residences/bathroom-scheme-dark.jpeg": 131,
	"./assets/images/residences/bathroom-scheme-light.jpeg": 477,
	"./assets/images/residences/illustration-living-room.png": 478,
	"./assets/images/residences/kitchen-scheme-dark.jpeg": 132,
	"./assets/images/residences/kitchen-scheme-light.jpeg": 133,
	"./assets/images/residences/sample-plans/plan-B5b-desktop-en.png": 309,
	"./assets/images/residences/sample-plans/plan-B5b-desktop-tc.png": 310,
	"./assets/images/residences/sample-plans/plan-B5b-mobile-en.png": 311,
	"./assets/images/residences/sample-plans/plan-B5b-mobile-tc.png": 312,
	"./assets/images/residences/sample-plans/plan-C2b-desktop-en.png": 313,
	"./assets/images/residences/sample-plans/plan-C2b-desktop-tc.png": 314,
	"./assets/images/residences/sample-plans/plan-C2b-mobile-en.png": 315,
	"./assets/images/residences/sample-plans/plan-C2b-mobile-tc.png": 316,
	"./assets/images/residences/sample-plans/plan-C5-desktop-en.png": 317,
	"./assets/images/residences/sample-plans/plan-C5-desktop-tc.png": 318,
	"./assets/images/residences/sample-plans/plan-C5-mobile-en.png": 319,
	"./assets/images/residences/sample-plans/plan-C5-mobile-tc.png": 320,
	"./assets/images/residences/sample-plans/plan-D3b-desktop-en.png": 321,
	"./assets/images/residences/sample-plans/plan-D3b-desktop-tc.png": 322,
	"./assets/images/residences/sample-plans/plan-D3b-mobile-en.png": 323,
	"./assets/images/residences/sample-plans/plan-D3b-mobile-tc.png": 324,
	"./assets/images/residences/sample-plans/plan-TH3-desktop-en.png": 325,
	"./assets/images/residences/sample-plans/plan-TH3-desktop-tc.png": 326,
	"./assets/images/residences/sample-plans/plan-TH3-mobile-en.png": 327,
	"./assets/images/residences/sample-plans/plan-TH3-mobile-tc.png": 328,
	"./components/ContentBlock": 21,
	"./components/ContentBlock.js": 21,
	"./components/FullImage": 90,
	"./components/FullImage.js": 90,
	"./components/GoogleMapBlock": 92,
	"./components/GoogleMapBlock.js": 92,
	"./components/Hero": 33,
	"./components/Hero.js": 33,
	"./components/Illustration": 64,
	"./components/Illustration.js": 64,
	"./components/Intl": 6,
	"./components/Intl.js": 6,
	"./components/Lines": 40,
	"./components/Lines.js": 40,
	"./components/LinkBlock": 34,
	"./components/LinkBlock.js": 34,
	"./components/Page": 16,
	"./components/Page.js": 16,
	"./components/TitleBlock": 29,
	"./components/TitleBlock.js": 29,
	"./components/animations/FadeUp": 13,
	"./components/animations/FadeUp.js": 13,
	"./components/animations/ParallaxImage": 32,
	"./components/animations/ParallaxImage.js": 32,
	"./components/footer/Footer": 159,
	"./components/footer/Footer.js": 159,
	"./components/footer/elements/Info": 162,
	"./components/footer/elements/Info.js": 162,
	"./components/footer/elements/Register": 160,
	"./components/footer/elements/Register.js": 160,
	"./components/layout/BackgroundVideo": 156,
	"./components/layout/BackgroundVideo.js": 156,
	"./components/layout/CompareCaption": 93,
	"./components/layout/CompareCaption.js": 93,
	"./components/layout/ImageCallout": 18,
	"./components/layout/ImageCallout.js": 18,
	"./components/layout/ImageCompare": 163,
	"./components/layout/ImageCompare.js": 163,
	"./components/layout/VideoPopup": 157,
	"./components/layout/VideoPopup.js": 157,
	"./components/logos/Kerrisdale": 76,
	"./components/logos/Kerrisdale.js": 76,
	"./components/logos/Logo": 77,
	"./components/logos/Logo.js": 77,
	"./components/menu/Menu": 149,
	"./components/menu/Menu.js": 149,
	"./components/menu/elements/DesktopClose": 154,
	"./components/menu/elements/DesktopClose.js": 154,
	"./components/menu/elements/Hamburger": 151,
	"./components/menu/elements/Hamburger.js": 151,
	"./components/menu/elements/Header": 150,
	"./components/menu/elements/Header.js": 150,
	"./components/menu/elements/HoverOverlay": 153,
	"./components/menu/elements/HoverOverlay.js": 153,
	"./components/menu/elements/Overlay": 152,
	"./components/menu/elements/Overlay.js": 152,
	"./components/typography/GoldTitle": 52,
	"./components/typography/GoldTitle.js": 52,
	"./components/typography/GradientButton": 161,
	"./components/typography/GradientButton.js": 161,
	"./components/typography/GradientText": 45,
	"./components/typography/GradientText.js": 45,
	"./components/typography/RoundButton": 25,
	"./components/typography/RoundButton.js": 25,
	"./components/typography/VideoButton": 158,
	"./components/typography/VideoButton.js": 158,
	"./config/app.conf": 10,
	"./config/app.conf.js": 10,
	"./config/locales/en": 100,
	"./config/locales/en.js": 100,
	"./config/locales/sc": 101,
	"./config/locales/sc.js": 101,
	"./config/locales/tc": 102,
	"./config/locales/tc.js": 102,
	"./data/location": 164,
	"./data/location.js": 164,
	"./data/map": 155,
	"./data/map.js": 155,
	"./data/menu": 37,
	"./data/menu.js": 37,
	"./index": 97,
	"./index.js": 97,
	"./pages/Amenities/Amenities": 480,
	"./pages/Amenities/Amenities.js": 480,
	"./pages/Amenities/sections/Callouts": 166,
	"./pages/Amenities/sections/Callouts.js": 166,
	"./pages/Amenities/sections/Curator": 165,
	"./pages/Amenities/sections/Curator.js": 165,
	"./pages/Appointment": 481,
	"./pages/Appointment.js": 481,
	"./pages/Contact/Contact": 482,
	"./pages/Contact/Contact.js": 482,
	"./pages/Creation/Creation": 483,
	"./pages/Creation/Creation.js": 483,
	"./pages/Creation/elements/Building": 167,
	"./pages/Creation/elements/Building.js": 167,
	"./pages/Creation/elements/Collage": 168,
	"./pages/Creation/elements/Collage.js": 168,
	"./pages/Creation/elements/ImageBlock": 94,
	"./pages/Creation/elements/ImageBlock.js": 94,
	"./pages/Creation/sections/Atelier": 169,
	"./pages/Creation/sections/Atelier.js": 169,
	"./pages/Creation/sections/Images": 170,
	"./pages/Creation/sections/Images.js": 170,
	"./pages/Design/Design": 484,
	"./pages/Design/Design.js": 484,
	"./pages/Design/sections/Callouts": 172,
	"./pages/Design/sections/Callouts.js": 172,
	"./pages/Design/sections/Collage": 171,
	"./pages/Design/sections/Collage.js": 171,
	"./pages/Home/Home": 485,
	"./pages/Home/Home.js": 485,
	"./pages/Home/sections/Hero": 173,
	"./pages/Home/sections/Hero.js": 173,
	"./pages/Location/Location": 486,
	"./pages/Location/Location.js": 486,
	"./pages/Location/sections/Callouts": 175,
	"./pages/Location/sections/Callouts.js": 175,
	"./pages/Location/sections/Map": 174,
	"./pages/Location/sections/Map.js": 174,
	"./pages/NotFound": 487,
	"./pages/NotFound.js": 487,
	"./pages/Philosophy/Philosophy": 488,
	"./pages/Philosophy/Philosophy.js": 488,
	"./pages/Philosophy/elements/Card": 177,
	"./pages/Philosophy/elements/Card.js": 177,
	"./pages/Philosophy/sections/Cards": 176,
	"./pages/Philosophy/sections/Cards.js": 176,
	"./pages/Register/Register": 489,
	"./pages/Register/Register.js": 489,
	"./pages/Register/elements/Checkbox": 490,
	"./pages/Register/elements/Checkbox.js": 490,
	"./pages/Register/elements/Form": 178,
	"./pages/Register/elements/Form.js": 178,
	"./pages/Register/elements/Input": 65,
	"./pages/Register/elements/Input.js": 65,
	"./pages/Register/elements/Select": 80,
	"./pages/Register/elements/Select.js": 80,
	"./pages/Residences/Residences": 491,
	"./pages/Residences/Residences.js": 491,
	"./pages/Residences/sections/Plans": 179,
	"./pages/Residences/sections/Plans.js": 179,
	"./pages/Thankyou": 493,
	"./pages/Thankyou.js": 493,
	"./plugins/Analytics/Analytics": 143,
	"./plugins/Analytics/Analytics.js": 143,
	"./plugins/Analytics/elements/GTM": 145,
	"./plugins/Analytics/elements/GTM.js": 145,
	"./plugins/Analytics/elements/GTag": 144,
	"./plugins/Analytics/elements/GTag.js": 144,
	"./plugins/Analytics/elements/Hotjar": 146,
	"./plugins/Analytics/elements/Hotjar.js": 146,
	"./plugins/OnUpdate": 38,
	"./plugins/OnUpdate.js": 38,
	"./plugins/SEO": 142,
	"./plugins/SEO.js": 142,
	"./plugins/insight": 78,
	"./plugins/insight.js": 78,
	"./plugins/language": 140,
	"./plugins/language.js": 140,
	"./plugins/prerender": 148,
	"./plugins/prerender.js": 148,
	"./plugins/scrollTop": 141,
	"./plugins/scrollTop.js": 141,
	"./plugins/sitemap-generator": 494,
	"./plugins/sitemap-generator.js": 494,
	"./redux/counter": 139,
	"./redux/counter.js": 139,
	"./redux/intl": 74,
	"./redux/intl.js": 74,
	"./redux/menu": 51,
	"./redux/menu.js": 51,
	"./redux/reducers": 138,
	"./redux/reducers.js": 138,
	"./redux/store": 137,
	"./redux/store.js": 137,
	"./routes": 75,
	"./routes.js": 75,
	"./styles/Templates": 53,
	"./styles/Templates.js": 53,
	"./styles/animations": 79,
	"./styles/animations.js": 79,
	"./styles/global": 136,
	"./styles/global.js": 136,
	"./styles/media": 4,
	"./styles/media.js": 4,
	"./styles/theme": 7,
	"./styles/theme.js": 7,
	"./styles/utils": 1,
	"./styles/utils.js": 1
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 732;